'use client';

import { useContext } from 'react';
import { TermsContext } from './terms.context';

export const useTerms = (): TermsContext => useContext(TermsContext);
